import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=1d53fe40"
import script from "./AppSwitcher.vue?vue&type=script&lang=js"
export * from "./AppSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports